var styles = {"message":"styles_message__3CcRS p2","list-title":"styles_list-title__H7Zvn mb1","listTitle":"styles_list-title__H7Zvn mb1","list":"styles_list__1_2R-","recap":"styles_recap__3inTd mt1","show-more":"styles_show-more__3MLeU","showMore":"styles_show-more__3MLeU","chevron":"styles_chevron__1zjZs"};

export default styles;
//# sourceMappingURL=styles.css.js.map
